export { L as LogoutReason } from '../../../dist/ILogoutPresenter-c7a8a33e.esm.js';
export { a as TokenAllowance, T as TokenAllowanceLimit } from '../../../dist/TokenAllowance-b5230f5c.esm.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-c002e3ca.esm.js';
import { c as _createClass, b as _classCallCheck, _ as _inherits, a as _createSuper, d as _defineProperty, e as _assertThisInitialized } from '../../../dist/createClass-3115abc1.esm.js';
import { success, failure, invariant } from '@lens-protocol/shared-kernel';
import { _ as _wrapNativeSuper } from '../../../dist/wrapNativeSuper-76ffa30e.esm.js';

var WalletLogin = /*#__PURE__*/function () {
  function WalletLogin(walletFactory, walletGateway, credentialsIssuer, credentialsWriter, activeWalletPresenter, walletLoginPresenter, activeProfileLoader) {
    _classCallCheck(this, WalletLogin);
    this.walletFactory = walletFactory;
    this.walletGateway = walletGateway;
    this.credentialsIssuer = credentialsIssuer;
    this.credentialsWriter = credentialsWriter;
    this.activeWalletPresenter = activeWalletPresenter;
    this.walletLoginPresenter = walletLoginPresenter;
    this.activeProfileLoader = activeProfileLoader;
  }
  _createClass(WalletLogin, [{
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var wallet, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.walletFactory.create(request);
            case 2:
              wallet = _context.sent;
              _context.next = 5;
              return this.credentialsIssuer.issueCredentials(wallet);
            case 5:
              result = _context.sent;
              if (!result.isFailure()) {
                _context.next = 9;
                break;
              }
              this.walletLoginPresenter.present(failure(result.error));
              return _context.abrupt("return");
            case 9:
              _context.next = 11;
              return this.walletGateway.save(wallet);
            case 11:
              _context.next = 13;
              return this.credentialsWriter.save(result.value);
            case 13:
              this.activeWalletPresenter.presentActiveWallet(wallet);
              _context.next = 16;
              return this.activeProfileLoader.loadActiveProfileByOwnerAddress(wallet.address, request.handle);
            case 16:
              this.walletLoginPresenter.present(success());
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function login(_x) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }]);
  return WalletLogin;
}();

var WalletLogout = /*#__PURE__*/function () {
  function WalletLogout(walletGateway, credentialsGateway, activeWallet, activeProfileGateway, activeProfilePresenter, activeWalletPresenter, logoutPresenter) {
    _classCallCheck(this, WalletLogout);
    this.walletGateway = walletGateway;
    this.credentialsGateway = credentialsGateway;
    this.activeWallet = activeWallet;
    this.activeProfileGateway = activeProfileGateway;
    this.activeProfilePresenter = activeProfilePresenter;
    this.activeWalletPresenter = activeWalletPresenter;
    this.logoutPresenter = logoutPresenter;
  }
  _createClass(WalletLogout, [{
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reason) {
        var activeWallet;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.activeWallet.requireActiveWallet();
            case 2:
              activeWallet = _context.sent;
              _context.next = 5;
              return this.walletGateway.reset();
            case 5:
              _context.next = 7;
              return this.activeProfileGateway.reset();
            case 7:
              this.activeWalletPresenter.presentActiveWallet(null);
              _context.next = 10;
              return this.activeProfilePresenter.presentActiveProfile(null);
            case 10:
              _context.next = 12;
              return this.credentialsGateway.invalidate();
            case 12:
              this.logoutPresenter.present(success({
                lastLoggedInWallet: activeWallet,
                logoutReason: reason
              }));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout(_x) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }]);
  return WalletLogout;
}();

var ActiveWallet = /*#__PURE__*/function () {
  function ActiveWallet(credentialsReader, walletGateway) {
    _classCallCheck(this, ActiveWallet);
    this.credentialsReader = credentialsReader;
    this.walletGateway = walletGateway;
  }
  _createClass(ActiveWallet, [{
    key: "getActiveWallet",
    value: function () {
      var _getActiveWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var credentials, wallet;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.credentialsReader.getCredentials();
            case 2:
              credentials = _context.sent;
              if (credentials) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", null);
            case 5:
              _context.next = 7;
              return this.walletGateway.getByAddress(credentials.address);
            case 7:
              wallet = _context.sent;
              invariant(wallet, 'Active wallet should exist when credentials are present');
              return _context.abrupt("return", wallet);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getActiveWallet() {
        return _getActiveWallet.apply(this, arguments);
      }
      return getActiveWallet;
    }()
  }, {
    key: "requireActiveWallet",
    value: function () {
      var _requireActiveWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var wallet;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getActiveWallet();
            case 2:
              wallet = _context2.sent;
              invariant(wallet, "Active wallet is not defined.\n       Make sure that the storage configuration (IStorageProvider) properly persists saves");
              return _context2.abrupt("return", wallet);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function requireActiveWallet() {
        return _requireActiveWallet.apply(this, arguments);
      }
      return requireActiveWallet;
    }()
  }]);
  return ActiveWallet;
}();

var InsufficientAllowanceError = /*#__PURE__*/function (_Error) {
  _inherits(InsufficientAllowanceError, _Error);
  var _super = _createSuper(InsufficientAllowanceError);
  function InsufficientAllowanceError(requestedAmount) {
    var _this;
    _classCallCheck(this, InsufficientAllowanceError);
    _this = _super.call(this, "Insufficient allowance to cover the requested ".concat(requestedAmount.asset.toString()));
    _defineProperty(_assertThisInitialized(_this), "name", 'InsufficientAllowanceError');
    _this.requestedAmount = requestedAmount;
    return _this;
  }
  return _createClass(InsufficientAllowanceError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var InsufficientFundsError = /*#__PURE__*/function (_Error2) {
  _inherits(InsufficientFundsError, _Error2);
  var _super2 = _createSuper(InsufficientFundsError);
  function InsufficientFundsError(requestedAmount) {
    var _this2;
    _classCallCheck(this, InsufficientFundsError);
    _this2 = _super2.call(this, "Insufficient funds to cover the requested ".concat(requestedAmount.asset.toString()));
    _defineProperty(_assertThisInitialized(_this2), "name", 'InsufficientFundsError');
    _this2.requestedAmount = requestedAmount;
    return _this2;
  }
  return _createClass(InsufficientFundsError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var TokenAvailability = /*#__PURE__*/function () {
  function TokenAvailability(balanceGateway, tokenGateway, activeWallet) {
    _classCallCheck(this, TokenAvailability);
    this.balanceGateway = balanceGateway;
    this.tokenGateway = tokenGateway;
    this.activeWallet = activeWallet;
  }
  _createClass(TokenAvailability, [{
    key: "checkAvailability",
    value: function () {
      var _checkAvailability = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var wallet, balance, allowance;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.activeWallet.requireActiveWallet();
            case 2:
              wallet = _context.sent;
              _context.next = 5;
              return this.balanceGateway.getBalanceFor(wallet, request.amount.asset);
            case 5:
              balance = _context.sent;
              if (!request.amount.gt(balance)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", failure(new InsufficientFundsError(request.amount)));
            case 8:
              _context.next = 10;
              return this.tokenGateway.getTransferAllowanceFor(request.amount.asset, wallet, request.spender);
            case 10:
              allowance = _context.sent;
              if (!request.amount.gt(allowance)) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", failure(new InsufficientAllowanceError(request.amount)));
            case 13:
              return _context.abrupt("return", success());
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkAvailability(_x) {
        return _checkAvailability.apply(this, arguments);
      }
      return checkAvailability;
    }()
  }]);
  return TokenAvailability;
}();

export { ActiveWallet, InsufficientAllowanceError, InsufficientFundsError, TokenAvailability, WalletLogin, WalletLogout };
